import React, { useRef } from 'react';
import { t } from 'Src/i18n';
import { useSelector } from 'react-redux';
import { ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP } from 'Components/utils/identifiers/constants';
import { Layer } from 'Components/frameworks/layer/Layer';
import { LayerHeaderProposal } from 'Components/widgets/layer-header-proposal/LayerHeaderProposal';
import { ICONS } from 'Components/utils/icon/icons';
import { AdditionalTransportLayerIcons } from 'Components/widgets/additional-transports/AdditionalTransportLayerIcons';
import { getIsLoadingAdditionalTransports } from 'Store/booking/booking.selector';
import { Title } from 'Components/frameworks/title/Title';
import { AdditionalTransportsWrapper } from './AdditionalTransportsWrapper';
type AdditionalTransportLayerProps = {
  proposal: Proposal;
  onClose: (arg0: any) => void;
  setSelectedTransport: (transportId: string) => void;
  errorTitle: string | null | undefined;
};
export const AdditionalTransportLayer = ({
  onClose,
  proposal,
  setSelectedTransport,
  errorTitle,
}: AdditionalTransportLayerProps) => {
  const layerRef = useRef<null | HTMLElement>(null);
  const layerTitle = t('booking.transport.alternativeSelection');
  const isLoading = useSelector(getIsLoadingAdditionalTransports);
  return (
    <Layer
      ariaLabel={layerTitle}
      ariaLabelledby={ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP}
      buttonLeft={{
        iconName: ICONS.ARROW_TAIL_LEFT,
        label: t('common.backNavigation'),
        onClick: onClose,
      }}
      closeLabel={t('common.close')}
      header={
        <LayerHeaderProposal
          id={ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP}
          layerTitle={layerTitle}
          proposal={proposal}
          totalPrice={t('booking.transport.additionalTransports.totalPrice')}
        />
      }
      onClose={onClose}
      ref={layerRef}
      dataTestId="AdditionalTransportLayer"
    >
      <AdditionalTransportLayerIcons />

      {!!errorTitle && !isLoading && (
        <Title className="mx-25 mt-30" theme="title-sans-n4">
          {errorTitle}
        </Title>
      )}

      <AdditionalTransportsWrapper
        proposal={proposal}
        setSelectedTransport={setSelectedTransport}
      />
    </Layer>
  );
};
